export const extractAddressString = (item: any): string => (item ? item.address : '');
